<template>
  <div id="popUpWin" v-bind:class="{active: popupState}">
    <div>
      <div class="imgBlock">
        <kari-app/>
        <p>Установить приложение</p>
        <button class="purpleButton" v-on:click="openStore">Открыть</button>
      </div>
    </div>
  </div>
</template>

<script>
import KariApp from '@/assets/svg/kariApp'

export default {
  name: 'install-app',
  components: { KariApp },
  props: {
    popupState: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openStore () {
      this.$parent.appPopup = false;
      const modelsRegex =
        /ALP-|AMN-|ARS-|ANE-|BAC-|BLA-|CAG-|CAM-|CAN-|CAZ-|CDL-|CLT-|CRO-|EVE-|RUNE-|BAL-|AND-|BNE-|DCO-|CET-|CHA-|GOT-|GLA-|NCO-|BAH4-|PAL-|ODN-|FRG-|MLY-|Ags3K-|AGS5-|MGA-|ABR-|JLN-|JuliaQN-|RMX2190-|FIO-|JSC-|WKG-|Wukong-|MLD-|MIL-|RTE-|Hebe-|NAM-|ANG-|JAD-|CHL-|NEN-|NOH-|OCE-|TET-|WGR-|MRR-|DBY-|BRQ-|AGRK-|ANA-|PPA-|NOP-|VID-|LIO-|BAH3-|FRL-|SCMR-|AGS3-|NIK-|DVC-|AQM-|CDY-|Kobe2-|KOB2-|MED-|DRA-|JER-|JEF-|HCT-|ELS-|ART-|JNY-|TAH-|WLZ-|MRX-|TAS-|LTN-|DAN-|LEM-|FGD-|XYAO-|BON-|CLB-|ALN-|ARA-|PNX-|ALT-|BRA-|DBY2-|STG-|MDS-|ARC-|GOA-|FOA-|MNA-|LNA-|DBR-/i;
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent);
      const isHuawei = /huawei/i.test(userAgent);
      const isHuaweiDevice = modelsRegex.test(navigator.userAgent);
      // alert('браузер Хуавей' + ' ' + isHuawei);
      // alert('устройство Хуавей' + ' ' + isHuaweiDevice);
      // alert(navigator.vendor);
      // alert(navigator.userAgent);
      if (isIOS) {
        window.open('https://apps.apple.com/ru/app/kari-обувь-и-аксессуары/id1497875223');
      } else if (isHuawei || isHuaweiDevice) {
        window.open('https://appgallery.cloud.huawei.com/ag/n/app/C107057313?locale=ru_RU');
      } else {
        window.open('https://play.google.com/store/apps/details?id=ru.kari.android');
      }
    }
  }
};
</script>

<style scoped>
#popUpWin { height: auto; display: flex; flex-direction: column; justify-content: space-between; transition: ease-out 0.4s; top: -10vh; position: absolute; opacity: 0 }
#popUpWin.active { top: 0; position: relative; opacity: 1 }
#popUpWin>div>.imgBlock { height: auto; flex-direction: row; justify-content: space-between; }
#popUpWin>div>.imgBlock>p { margin-bottom: 2.13vw; text-align: center }
#popUpWin>div>.imgBlock>svg { height: 5vh }
#popUpWin>div>.imgBlock>.purpleButton { height: 5vh }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { display: none }
}

</style>
